import { Box, Stack, Typography } from '@mui/material';
import { FC } from 'react';
export interface HaistAICardProps {
  index: number;
  title: string;
  description: string;
  image: string;
}

const Step = ({
  stepIcon,
  text,
  color,
  backgroundColor,
}: {
  stepIcon: string;
  text: string;
  color: string;
  backgroundColor: string;
}) => {
  return (
    <Stack
      spacing={{
        xs: '6px',
        sm: '8px',
        md: '10px',
      }}
      direction="row"
      sx={{
        height: {
          xs: '24px',
          sm: '30px',
          md: '40px',
        },
        padding: {
          xs: '6px',
          sm: '6px',
          md: '8px 14px',
        },
        borderRadius: {
          xs: '6px',
          sm: '6px',
          md: '8px',
        },
        backgroundColor: backgroundColor,
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Box
        component="img"
        src={stepIcon}
        alt="Step Icon"
        sx={{
          width: {
            xs: '12px',
            sm: '15px',
            md: '20px',
          },
          height: {
            xs: '12px',
            sm: '15px',
            md: '20px',
          },
        }}
      />
      <Typography
        fontWeight={500}
        fontSize={{
          xs: 9,
          sm: 12,
          md: 16,
        }}
        sx={{ color: color }}
      >
        {text}
      </Typography>
    </Stack>
  );
};

const STEP_COLORS = ['#12A250', '#A29B12', '#237BC3', '#CB592C'];
const STEP_BACKGROUND_COLORS = ['#D6F9E5', '#F3F9D6', '#D7D6F9', '#F9E0D6'];
const HaistAICard: FC<HaistAICardProps> = ({
  index,
  title,
  description,
  image,
}) => {
  return (
    <Stack
      direction="column"
      spacing={'24px'}
      sx={{
        minHeight: {
          xs: '349px',
          sm: '444px',
          md: '476px',
        },
        height: {
          xs: '349px',
          sm: '444px',
          md: '476px',
        },
        minWidth: '100%',
        width: '100%',
        maxWidth: '100%',
        padding: {
          xs: '20px',
          sm: '28px',
          md: '28px',
        },
        justifyContent: 'space-evenly',
        alignItems: 'stretch', // 변경: flex-start -> stretch
        borderRadius: '12px',
        border: '1px solid #EEEEEE',
        background: '#FFFFFFD9',
      }}
    >
      <Stack
        direction="column"
        spacing={'15px'}
        sx={{
          justifyContent: 'flex-start',
          alignItems: 'flex-start',
        }}
      >
        <Step
          stepIcon={`/images/step_icon${index + 1}.svg`}
          color={STEP_COLORS[index]}
          backgroundColor={STEP_BACKGROUND_COLORS[index]}
          text={`STEP ${index + 1}`}
        />
        <Stack
          direction="column"
          spacing={'6px'}
          sx={{
            justifyContent: 'flex-start',
            alignItems: 'flex-start',
            minWidth: 0,
          }}
        >
          <Typography
            fontWeight={600}
            fontSize={{
              xs: 18,
              sm: 24,
              md: 28,
            }}
            align="left"
            sx={{
              color: '#1D2026',
              lineHeight: '24px',
              letterSpacing: '-0.16px',
            }}
          >
            {title}
          </Typography>
          <Typography
            fontWeight={400}
            fontSize={14}
            align="left"
            sx={{
              display: 'block', // ✅ 줄바꿈 허용을 확실히
              whiteSpace: 'normal',
              wordBreak: 'break-word',
              overflowWrap: 'break-word',
              maxWidth: '100%',
              flexShrink: 1, // ✅ 영역 강제 축소 방지
              color: '#46464A',
            }}
          >
            {description}
          </Typography>
        </Stack>
        <Stack
          direction="row"
          spacing={'10px'}
          sx={{
            justifyContent: 'flex-start',
            alignItems: 'center',
          }}
        >
          <Typography
            fontWeight={500}
            fontSize={16}
            sx={{
              color: '#1D2026',
            }}
          >
            Learn More
          </Typography>
          <img src={'/images/learn_more.svg'} alt={'learn more'} />
        </Stack>
      </Stack>
      <Box
        sx={{
          width: '100%',
          minWidth: 0,
          maxWidth: '100%', // 추가
          height: '230px',
          backgroundImage: `url(${image})`,
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          borderRadius: '12px',
          overflow: 'hidden',
          flexShrink: 1,
        }}
      />
    </Stack>
  );
};

export default HaistAICard;
